import React, { useState } from "react";
import "./SendJoinLinkModal.css";

import {
  generatePatientMeetingURL,
  getCurrentSessionId,
} from "./utils/meetingEncryptor";


const SendJoinLinkModal = ({
  patient = "John Smith",
  onClose,
  onSent,
}) => {


  const [method, setMethod] = useState("SMS");

  const [recipient, setRecipient] =
    useState("555-555-1212");


  const [generated, setGenerated] =
    useState(false);


  const [joinURL, setJoinURL] =
    useState("");



  const handleGenerate = () => {


    /*
      Uses the SAME encounter session
      as provider launch
    */

    const session =
      getCurrentSessionId();


    const url =
      generatePatientMeetingURL(
        patient
      );


    console.log(
      "Patient session:",
      session
    );


    setJoinURL(url);

    setGenerated(true);


    if (onSent) {
      onSent();
    }

  };



  return (

    <div className="modal-overlay">


      <div className="join-modal">


        <div className="modal-header">

          <h2>
            Send Direct Join Link
          </h2>

          <button
            onClick={onClose}
            className="close-btn"
          >
            ×
          </button>

        </div>




        {!generated ? (


          <>


            <p className="modal-description">

              Send a secure virtual visit
              invitation to the patient.

            </p>



            <div className="method-select">


              <label>

                <input

                  type="radio"

                  checked={method === "SMS"}

                  onChange={() =>
                    setMethod("SMS")
                  }

                />

                SMS

              </label>



              <label>

                <input

                  type="radio"

                  checked={method === "Email"}

                  onChange={() =>
                    setMethod("Email")
                  }

                />

                Email

              </label>


            </div>




            <label className="input-label">

              Recipient

            </label>


            <input

              className="recipient-input"

              value={recipient}

              onChange={(e) =>
                setRecipient(
                  e.target.value
                )
              }

            />




            <button

              className="generate-btn"

              onClick={handleGenerate}

            >

              Generate Secure Link

            </button>


          </>


        ) : (


          <>


            <div className="success-message">

              ✓ Invitation Sent

            </div>




            <div className="sent-details">


              <p>

                <strong>
                  Delivery:
                </strong>

                {" "}
                {method}

              </p>


              <p>

                <strong>
                  Recipient:
                </strong>

                {" "}
                {recipient}

              </p>



            </div>





            <label className="input-label">

              Patient Join URL

            </label>


            <div className="patient-link-container">

              <a
                href={joinURL}
                target="_blank"
                rel="noopener noreferrer"
                className="patient-launch-link"
              >

                Patient Launch URL

              </a>


              <p className="link-description">

                Opens the secure patient virtual visit window.

              </p>


            </div>



          </>


        )}



      </div>


    </div>

  );

};


export default SendJoinLinkModal;